import { useRouter } from 'next/router';
import { useCallback } from 'react';

export const getNavigationState = () => {
  if (typeof window === 'undefined') {
    return { backPath: '/' };
  }

  return {
    backPath: window.location.pathname + window.location.search,
  };
};

export const useNavigate = () => {
  const router = useRouter();

  return useCallback(
    (to: string | number) => {
      if (typeof to === 'number') {
        window.history.go(to);
        return;
      }

      router.push(to);
    },
    [router]
  );
};

export const useBackPath = (defaultPath: string) => {
  const router = useRouter();
  const backPath = router.query.backPath;

  if (typeof backPath === 'string') {
    return backPath;
  }

  return defaultPath;
};

export { useRouter as useLocation };
